import { useState, useEffect } from "react";

/**
 * Custom hook to detect mobile devices
 * Uses window.innerWidth with debouncing for performance
 * Only updates on resize, doesn't affect initial render
 */
export const useIsMobile = () => {
  // Initialize with undefined to avoid hydration mismatch
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth < 768;
    }
    return false;
  });

  useEffect(() => {
    // Only set up listener if we're in browser
    if (typeof window === "undefined") return;

    let timeoutId;
    const handleResize = () => {
      // Debounce resize events for performance
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(window.innerWidth < 768);
      }, 150);
    };

    window.addEventListener("resize", handleResize, { passive: true });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};
